import * as CartService from '../services/CartService'

export const FETCH_CART_REQUEST = 'FETCH_CART_REQUEST';
export const FETCH_CART_SUCCESS = 'FETCH_CART_SUCCESS';
export const FETCH_CART_FAILURE = 'FETCH_CART_FAILURE';

export function fetchCartRequest() {
    return {
        type: FETCH_CART_REQUEST
    }
}

export function fetchCartSuccess(payload) {
    return {
        type: FETCH_CART_SUCCESS,
        payload
    }
}

export function fetchCartFailure(payload) {
    return {
        type: FETCH_CART_FAILURE,
        payload
    }
}

export function fetchCart() {
    return (dispatch) => {
        dispatch(fetchCartRequest());

        CartService.fetchCart()
            .then(response => {
                dispatch(fetchCartSuccess(response));
            })
            .catch(error => {
                dispatch(fetchCartFailure(error));
            });
    }
}
